import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Alert, AlertDescription } from '../../components/ui/alert';
import { AlertTriangle } from 'lucide-react';

export default function AdPlacementsTab({ placements }) {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Ad Placement Overview</CardTitle>
          <CardDescription>Current ad placements across the platform</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            {placements.map((placement) => (
              <div
                key={placement.id}
                className="flex items-center justify-between p-4 border rounded-lg"
              >
                <div>
                  <h4 className="font-medium">{placement.name}</h4>
                  <p className="text-sm text-muted-foreground">{placement.description}</p>
                </div>
                <div className="flex items-center gap-2">
                  <Badge variant="outline">
                    {placement.sizes.map((s) => `${s[0]}x${s[1]}`).join(', ')}
                  </Badge>
                  <Badge variant={placement.active ? 'default' : 'secondary'}>
                    {placement.active ? 'Active' : 'Inactive'}
                  </Badge>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Ad Source Priority</CardTitle>
          <CardDescription>
            How ads are served when multiple sources are available
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ol className="list-decimal list-inside space-y-2 text-sm">
            <li>
              <strong>Partner/Sponsor Ads</strong> - Internal promotional content with highest
              priority
            </li>
            <li>
              <strong>Member Ads</strong> - Pro/Premium member promotional pages
            </li>
            <li>
              <strong>Google Ad Manager</strong> - Programmatic ads when no internal ads
              available
            </li>
          </ol>
          <Alert className="mt-4">
            <AlertTriangle className="w-4 h-4" />
            <AlertDescription>
              Partner ads always take priority over Google ads to maximize revenue from direct
              partnerships.
            </AlertDescription>
          </Alert>
        </CardContent>
      </Card>
    </>
  );
}
